/* JHSN cart drawer fix: when the drawer was rendered empty (no <cart-items> on the page), the stock theme never re-rendered it after an add-to-cart. Re-render the drawer body from the bundled section HTML instead. */
(function () {
  var tries = 0;
  function start() {
    if (!(window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS)) {
      if (tries++ < 60) setTimeout(start, 200);
      return;
    }
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      try {
        var drawer = document.getElementById('CartDrawer');
        var cart = event && event.cart;
        if (!drawer || !cart || cart.errors) return;
        if (drawer.querySelector('cart-items')) return; /* stock handler already does it */
        var id = drawer.getAttribute('data-section-id');
        var html = cart.sections && cart.sections[id];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.getElementById('MiniCart-' + id);
          var dst = document.getElementById('MiniCart-' + id);
          if (src && dst) {
            dst.innerHTML = src.innerHTML;
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            return;
          }
        }
        if (cart.item_count > 0) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      }
      catch (e) { console.error(e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* JHSN automatic shipping protection (Icons Footwear): ON by default as soon as a real product is in the cart.
   VIP+ is NOT added automatically (Tom, 24-10-2026): the customer has to join VIP+ in the cart card themselves.
   A customer can opt out of protection in the cart (untick); that choice is remembered for the visit (sessionStorage) and cleared when the cart is empty. */
(function () {
  var CODE = 'ICONS VIP+';
  var VIP_HANDLE = 'icons-footwear-vip';
  var P_OPT = 'jhsnProtOptOut', V_OPT = 'jhsnVipOptOut';
  var working = false, planId = 0, tries = 0;
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  function flag(k) { try { return sessionStorage.getItem(k) === '1'; } catch (e) { return false; } }
  function setFlag(k, on) { try { on ? sessionStorage.setItem(k, '1') : sessionStorage.removeItem(k); } catch (e) { /* ignore */ } }
  function ids() {
    var d = document.getElementById('CartDrawer');
    if (!d) return null;
    return { prot: parseInt(d.getAttribute('data-protection-variant'), 10) || 0, vip: parseInt(d.getAttribute('data-vip-variant'), 10) || 0, section: d.getAttribute('data-section-id') };
  }
  function getPlan() {
    if (planId) return Promise.resolve(planId);
    return fetch('/products/' + VIP_HANDLE + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var g = p.selling_plan_groups && p.selling_plan_groups[0];
      planId = g && g.selling_plans && g.selling_plans[0] ? g.selling_plans[0].id : 0;
      return planId;
    }).catch(function () { return 0; });
  }
  function check(source) {
    var s = ids();
    if (!s || working) return;
    working = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var real = 0, hasProt = false, hasVip = false;
      c.items.forEach(function (i) {
        if (s.prot && i.variant_id === s.prot) hasProt = true;
        else if (s.vip && i.variant_id === s.vip) hasVip = true;
        else real += i.quantity;
      });
      if (real === 0) { setFlag(P_OPT, false); setFlag(V_OPT, false); working = false; return; }
      /* remember explicit choices made in the cart */
      if (source === 'cart-protection') setFlag(P_OPT, !hasProt);
      if (source === 'cart-vip') setFlag(V_OPT, !hasVip);
      var wantProt = s.prot && !hasProt && !flag(P_OPT);
      var wantVip = false; /* VIP+ is opt-in: never added automatically */
      if (!wantProt && !wantVip) { working = false; return; }
      return (wantVip ? getPlan() : Promise.resolve(0)).then(function (plan) {
        var items = [];
        if (wantProt) items.push({ id: s.prot, quantity: 1 });
        if (wantVip && plan) items.push({ id: s.vip, quantity: 1, selling_plan: plan });
        if (!items.length) { working = false; return; }
        var pre = wantVip && plan ? fetch('/discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
        return pre.then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: items, sections: [s.section], sections_url: window.location.pathname }) });
        }).then(function (r) { return r.json(); }).then(function (added) {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = added.sections;
            working = false;
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'jhsn-auto', cart: cart });
          });
        });
      });
    }).catch(function () { working = false; });
  }
  function start() {
    if (!(window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS)) {
      if (tries++ < 60) setTimeout(start, 200);
      return;
    }
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      var src = event && event.source;
      if (src === 'jhsn-auto' || src === 'jhsn-timer') return;
      setTimeout(function () { check(src); }, 300);
    });
    check('load');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---- Cart icon count: only real products count, not the VIP+ membership or the shipping protection (Tom, 23-10-2026).
   Only reacts to changes inside a <cart-count> (or new nodes containing one). ---- */
(function () {
  var HANDLES = ['shipping-protection', 'icons-footwear-vip'];
  var timer = null;
  function fix() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var n = c.items.reduce(function (s, i) { return HANDLES.indexOf(i.handle) > -1 ? s : s + i.quantity; }, 0);
      document.querySelectorAll('cart-count').forEach(function (el) {
        if (n < 100 && el.textContent.trim() !== String(n)) el.textContent = String(n);
        el.hidden = n === 0;
      });
    }).catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(fix, 150); }
  function touches(m) {
    var t = m.target && (m.target.nodeType === 1 ? m.target : m.target.parentElement);
    if (t && t.closest && t.closest('cart-count')) return true;
    for (var i = 0; i < m.addedNodes.length; i++) {
      var a = m.addedNodes[i];
      if (a.nodeType === 1 && (a.matches('cart-count') || a.querySelector('cart-count'))) return true;
    }
    return false;
  }
  function init() {
    schedule();
    new MutationObserver(function (list) { if (list.some(touches)) schedule(); }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();